export default "__VITE_ASSET__o$TrioOx__"